import { render, staticRenderFns } from "./CloudAccountSetupSummary.vue?vue&type=template&id=72c1f5f2&scoped=true"
import script from "./CloudAccountSetupSummary.vue?vue&type=script&lang=js"
export * from "./CloudAccountSetupSummary.vue?vue&type=script&lang=js"
import style0 from "./CloudAccountSetupSummary.vue?vue&type=style&index=0&id=72c1f5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1f5f2",
  null
  
)

export default component.exports